export interface UserBadge {
    order?: number | null;
    type: string;
}
